import type {PreOrderRetrieveResponse} from '@yandex-delivery/api/repo/dcaa'

import type {PaymentInfoDetails} from 'src/shared/types'

export const toPaymentInfo = (preOrderRetrieve: PreOrderRetrieveResponse): PaymentInfoDetails | undefined => {
  const paymentInfo = preOrderRetrieve.claim.payment_info

  if (!paymentInfo) return

  if (paymentInfo.kind && paymentInfo.method_id && paymentInfo.type) {
    return {
      type: paymentInfo.type,
      kind: paymentInfo.kind,
      methodId: paymentInfo.method_id,
      hasDisableReason: false,
    }
  }
}
